import './transitions.less';

import PropTypes from 'prop-types';

import React from 'react';

import { CSSTransitionGroup as ReactCSSTransitionGroup } from 'react-transition-group';

const OpacityTransition = ({ children, speed, ...rest })=> {

  const msTimeout = {
    fast: 150,
    normal: 300
  }[speed];

  return (
    <ReactCSSTransitionGroup 
      transitionName={`zfTransitions-Opacity-${speed}`}
      transitionEnterTimeout={msTimeout} 
      transitionLeaveTimeout={msTimeout}
      transitionAppearTimeout={msTimeout}
      {...rest}>
      { children }
    </ReactCSSTransitionGroup>
  );
};

OpacityTransition.propTypes = {
  speed: PropTypes.oneOf(['fast', 'normal'])
};
OpacityTransition.defaultProps = {
  speed: 'normal'
};

const ScaleYTransition = ({ children, ...rest })=> (
  <ReactCSSTransitionGroup 
    transitionName="zfTransitions-ScaleYTransformFast" 
    transitionEnterTimeout={300} 
    transitionLeaveTimeout={300}
    transitionAppearTimeout={300}
    {...rest}>
    { children }
  </ReactCSSTransitionGroup>
);


const SmallHeightTransition = ({ children, ...rest })=> (
  <ReactCSSTransitionGroup 
    transitionName="zfTransitions-SmallHeight" 
    transitionEnterTimeout={300} 
    transitionLeaveTimeout={300}
    transitionAppearTimeout={300}
    {...rest}>
    { children }
  </ReactCSSTransitionGroup>
);




export {
  OpacityTransition,
  ScaleYTransition,
  SmallHeightTransition
};
